/**
 * Se o usuário pode moderar a elegibilidade de interoperabilidade (ligar/desligar
 * can_tenant_bind). É ação sensível — abre a replicação de dados do tenant para o cross —,
 * por isso tem permissão dedicada, separada do acesso ao módulo (DASH_INTEROPERABILITY).
 *
 * O backend também cobra a permissão (403); isto aqui só esconde a aba de quem não pode.
 */
export const canModerateInteroperability = (): boolean => {
  try {
    const user = JSON.parse(localStorage.getItem('auth-user') || 'null');
    return !!user?.permissions?.some(
      (permission: { role_id?: string; status?: unknown }) =>
        permission.role_id === 'DASH_INTEROPERABILITY_MODERATE' && !!permission.status,
    );
  } catch {
    return false;
  }
};
